import { render } from "./BonPriseEnChargeLayout.vue?vue&type=template&id=555f872b&lang=true"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__